export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 13;
export const KEY = "bcbeffaf-eb15-4654-987f-cb0b6f368d67";
export const MODAL_CLOSE_SEC = 2.5;
